// constants.js
export const ROLES = {
  ADMIN: "ADMIN",
  SITE_BUSINESS_HEAD: "SITE_BUSINESS_HEAD",
  PLANT_HEAD: "PLANT_HEAD",
  MANAGER: "MANAGER",
  SUPERVISOR: "SUPERVISOR",
  TECHNICIAN: "TECHNICIAN",
  PLANNING_ENGINEER: "PLANNING_ENGINEER",
  PLANNING_MANAGER: "PLANNING_MANAGER",
  IE_ENGINEER: "IE_ENGINEER",
  IE_MANAGER: "IE_MANAGER",
};

// Role-based default route for now
export const DEFAULT_ROUTES = {
  [ROLES.ADMIN]: "/admin/user",
  [ROLES.SITE_BUSINESS_HEAD]: "/admin/lhbData",
  [ROLES.PLANT_HEAD]: "/admin/lhbData",
  [ROLES.MANAGER]: "/admin/lhbData",
  [ROLES.SUPERVISOR]: "/admin/lhbData",
  [ROLES.TECHNICIAN]: "/admin/dashboard",
  [ROLES.PLANNING_ENGINEER]: "/admin/customer",
  [ROLES.PLANNING_MANAGER]: "/admin/lhbData",
  [ROLES.IE_ENGINEER]: "/admin/customer",
  [ROLES.IE_MANAGER]: "/admin/lhbData",
};

export const ACTIONS = Object.freeze({
  VIEW: "VIEW",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
});

export const ROLE_GROUPS = {
  ALL: [
    ROLES.ADMIN,
    ROLES.SITE_BUSINESS_HEAD,
    ROLES.PLANT_HEAD,
    ROLES.MANAGER,
    ROLES.SUPERVISOR,
    ROLES.IE_ENGINEER,
    ROLES.IE_MANAGER,
    ROLES.PLANNING_ENGINEER,
    ROLES.PLANNING_MANAGER,
  ],
  OPERATIONS: [ROLES.MANAGER, ROLES.SUPERVISOR],
  ENGINEERING: [ROLES.IE_ENGINEER, ROLES.IE_MANAGER],
  PLANNING: [ROLES.PLANNING_ENGINEER, ROLES.PLANNING_MANAGER],
  TOP_LEVEL: [ROLES.ADMIN, ROLES.SITE_BUSINESS_HEAD, ROLES.PLANT_HEAD],
  ADMIN_ONLY: [ROLES.ADMIN],
};

export const ACCESS_CONFIG = {
  INTERNAL_USERS: {
    VIEW: [ROLES.SITE_BUSINESS_HEAD, ROLES.PLANT_HEAD, ROLES.ADMIN],
    CREATE: ROLE_GROUPS.ADMIN_ONLY,
    UPDATE: ROLE_GROUPS.ADMIN_ONLY,
    DELETE: ROLE_GROUPS.ADMIN_ONLY,
  },

  TECHNICIAN_MASTER: {
    VIEW: [
      ROLES.SITE_BUSINESS_HEAD,
      ROLES.PLANT_HEAD,
      ROLES.MANAGER,
      ROLES.SUPERVISOR,
      ROLES.ADMIN,
    ],
    CREATE: [ROLES.MANAGER, ROLES.SUPERVISOR, ROLES.ADMIN],
    UPDATE: [ROLES.MANAGER, ROLES.SUPERVISOR, ROLES.ADMIN],
    DELETE: [ROLES.MANAGER, ROLES.SUPERVISOR, ROLES.ADMIN],
  },

  CUSTOMER_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
  },

  DEPARTMENT_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
  },

  //SATTION ,UNIT
  COMMON_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
  },

  UNIT_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
  },

  SHIFT_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.ADMIN_ONLY, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.ADMIN_ONLY, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.ADMIN_ONLY, ROLES.ADMIN],
  },

  DUTY_TYPE_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.ADMIN_ONLY, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.ADMIN_ONLY, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.ADMIN_ONLY, ROLES.ADMIN],
  },

  PROJECT_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
  },

  PRODUCT_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.PLANNING, ROLES.ADMIN],
  },

  SUBACTIVITY_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
  },

  MICROACTIVITY_MASTER: {
    VIEW: ROLE_GROUPS.ALL,
    CREATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    UPDATE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
    DELETE: [...ROLE_GROUPS.ENGINEERING, ROLES.ADMIN],
  },
  REMARK_MASTER: {
    VIEW: [...ROLE_GROUPS.ALL, ROLES.ADMIN],
    CREATE: ROLE_GROUPS.ADMIN_ONLY,
    UPDATE: ROLE_GROUPS.ADMIN_ONLY,
    DELETE: ROLE_GROUPS.ADMIN_ONLY,
  },

  CONTRACTOR_MASTER: {
    VIEW: [
      ROLES.ADMIN,
      ROLES.SITE_BUSINESS_HEAD,
      ROLES.PLANT_HEAD,
      ROLES.MANAGER,
      ROLES.IE_ENGINEER,
      ROLES.IE_MANAGER,
      ROLES.PLANNING_ENGINEER,
      ROLES.PLANNING_MANAGER,
    ],
    CREATE: [ROLES.MANAGER, ROLES.ADMIN],
    UPDATE: [ROLES.MANAGER, ROLES.ADMIN],
    DELETE: [ROLES.MANAGER, ROLES.ADMIN],
  },

  REPORTS_MASTER: {
    VIEW: [ROLES.ADMIN, ROLES.IE_MANAGER, ROLES.PLANT_HEAD],
    CREATE: [ROLES.ADMIN, ROLES.IE_MANAGER, ROLES.PLANT_HEAD],
    UPDATE: [ROLES.ADMIN, ROLES.IE_MANAGER, ROLES.PLANT_HEAD],
    DELETE: [ROLES.ADMIN, ROLES.IE_MANAGER, ROLES.PLANT_HEAD],
  },

  LHB_DATA: {
    VIEW: [
      ROLES.ADMIN,
      ROLES.SITE_BUSINESS_HEAD,
      ROLES.PLANT_HEAD,
      ROLES.MANAGER,
      ROLES.SUPERVISOR,
      ROLES.IE_MANAGER,
      ROLES.PLANNING_MANAGER,
    ],
    CREATE: [
      ROLES.ADMIN,
      ROLES.SITE_BUSINESS_HEAD,
      ROLES.PLANT_HEAD,
      ROLES.MANAGER,
      ROLES.SUPERVISOR,
      ROLES.IE_MANAGER,
      ROLES.PLANNING_MANAGER,
    ],
    UPDATE: [
      ROLES.ADMIN,
      ROLES.SITE_BUSINESS_HEAD,
      ROLES.PLANT_HEAD,
      ROLES.MANAGER,
      ROLES.SUPERVISOR,
      ROLES.IE_MANAGER,
      ROLES.PLANNING_MANAGER,
    ],
    DELETE: [
      ROLES.ADMIN,
      ROLES.SITE_BUSINESS_HEAD,
      ROLES.PLANT_HEAD,
      ROLES.MANAGER,
      ROLES.SUPERVISOR,
      ROLES.IE_MANAGER,
      ROLES.PLANNING_MANAGER,
    ],
  },
};
export const hasAccess = (module, action = "VIEW") => {
  const roles = ACCESS_CONFIG?.[module]?.[action];
  return Array.isArray(roles) ? roles : [];
};

export const STATUS = [
  { label: "ACTIVE", value: "Active" },
  { label: "INACTIVE", value: "Inactive" },
];

export const GENDER = [
  { label: "Male", value: "MALE" },
  { label: "Female", value: "FEMALE" },
  { label: "Other", value: "OTHER" },
];

export const activityTypeOptions = [
  { label: "Direct", value: "DIRECT" },
  { label: "Indirect", value: "INDIRECT" },
  { label: "Idle", value: "IDLE" },
  { label: "Waiting", value: "WAITING" },
];

//Regex
export const REGEX = {
  //email regex
  EMAIL_REGEX:
    /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/,
};

export const DEFAULT_RECORDS_PER_PAGE = 25;

export const DASHBOARD_STATUS = [
  {
    value: "ACTIVE",
    label: "Active",
  },
  {
    value: "INACTIVE",
    label: "Inactive",
  },
  {
    value: "ALL",
    label: "All",
  },
];

export const DATE_RANGE_OPTIONS = [
  { label: "Today", value: "TODAY" },
  { label: "Last 1 Day", value: "1" },
  { label: "Last 7 Days", value: "7" },
  { label: "Last 30 Days", value: "30" },
  { label: "Last 90 Days", value: "90" },
  { label: "Custom", value: "CUSTOM" },
];

export const REMARK_OPTIONS = [
  {
    label: "Fresh",
    value: "FRESH",
  },
  {
    label: "Rework",
    value: "REWORK",
  },
];

export const MASTER_OPTIONS = [
  { label: "Internal User", value: "INTERNAL_USER" },
  { label: "Technician", value: "TECHNICIAN" },
  { label: "Customer", value: "CUSTOMER" },
  { label: "Department", value: "DEPARTMENT" },
  { label: "Station", value: "STATION" },
  { label: "Shift", value: "SHIFT" },
  { label: "Unit", value: "UNIT" },
  { label: "Duty Type", value: "DUTY_TYPE" },
  { label: "Project", value: "PROJECT" },
  { label: "Sub Activity", value: "SUB_ACTIVITY" },
  { label: "Micro Activity", value: "MICRO_ACTIVITY" },
  { label: "Product", value: "PRODUCT" },
  { label: "Remark", value: "REMARK" },
  { label: "Contractor", value: "CONTRACTOR" },
];

export const ACTION_OPTIONS = [
  { label: "ADD", value: "ADD" },
  { label: "EDIT", value: "EDIT" },
  { label: "DELETE", value: "DELETE" },
];

export const AGGREGATE_OPTIONS = [{ label: "Aggregate", value: "Aggregate" }, {label: "Individual", value: ""}];